import { render } from "./PaginationDots.vue?vue&type=template&id=013279ee&scoped=true"
import script from "./PaginationDots.vue?vue&type=script&lang=js"
export * from "./PaginationDots.vue?vue&type=script&lang=js"

import "./PaginationDots.vue?vue&type=style&index=0&id=013279ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013279ee"]])

export default __exports__